import Container from '../../components/Container';
import Heading from '../../components/Heading';
import ContactCard from './ContactCard';

const ContactClient = ({contactCard}) => {
    return (
        <section className='bg-secondary-black py-5'>
            <Container className="py-0 py-lg-5">
                <div className='row'>
                    <div className='col-12'>
                        <Heading 
                            heading={'Contact Us'}
                        />
                    </div>
                </div>
                {contactCard && 
                    <div className='row mt-5 pt-0 pt-lg-5'>
                        {contactCard.map((item,index) =>
                            <div className='col-12 col-sm-6 col-lg-4 mb-4 mb-lg-0' key={index}>
                                <ContactCard 
                                    icon={item.icon}
                                    title={item.title}
                                    description={item.description}
                                    contact={item.contact}
                                />                            
                            </div>
                        )}                       
                    </div>
                }
                
            </Container>
        </section>
    );
};

export default ContactClient;